// Copyright (c) 2021, Comsearch, Inc., All rights reserved

import { useContext } from 'react'
import { pathCartStoreActionsContext } from 'components/PathCart/contexts'

/**
 * @typedef {Object} pathCartStoreActions
 * @property {function} addPathToCartStore - adds the provided path to store
 * @property {function} addPathsToCartStore - adds the provided paths to store
 * @property {function} clearAllPaths - removes all paths from store
 * @property {function} getLatestDataForPathsAndSetPathCartStore - takes array of path ids, fetches their data from API and replaces Cart state with that update.
 * @property {function} removePathById - removes path by id from store
 * @property {function} removePathsById - removes paths by id from store
 */

/**
 * Returns the value of the pathCartStoreActionsContext
 * @returns {pathCartStoreActions}
 */

const usePathCartActionsContext = () => (
  useContext(pathCartStoreActionsContext)
)

export default usePathCartActionsContext
